import {Injectable} from '@angular/core';
import {getLink, Link, PREFIX_MAP, ROUTE_MAP} from "../models/mapping.model";
import {BehaviorSubject} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class QuickLinkService {

    onLinkClick: BehaviorSubject<string> = new BehaviorSubject<string>('');


    constructor() {


    }

    setLinkAsync(url: string) {
        setTimeout(() => {
            this.setLink(url);
        }, 0);
    }

    setLink(url: string) {
        let route = url.split('?')[0];
        let segments = route.split('/');
        if (segments.length < 3) {
            return;
        }
        route = segments[1] + '/' + segments[2];
        let data = localStorage.getItem('quickLinks') || '[]';
        let links: QuickLink[] = JSON.parse(data);
        let prefix = ROUTE_MAP[route];
        if (!prefix) {
            return;
        }
        let index = links.findIndex(x => x.prefix === prefix);
        if (index > -1) {
            links[index].visits++;
            links[index].lastVisited = new Date();
        } else {
            let link = this.createLink(route);
            if (!link) {
                return;
            }
            links.push(link);
        }
        links = links.sort((a, b) => (a.visits > b.visits) ? -1 : (a.visits === b.visits) ? ((a.lastVisited > b.lastVisited) ? -1 : 1) : 1);

        let totalVisits = links.reduce((acc, curr) => acc + curr.visits, 0);
        if(totalVisits > 100) {
            links = links.map(x => {
                x.visits = Math.round(x.visits / totalVisits * 100);
                return x;
            });
        }
        localStorage.setItem('quickLinks', JSON.stringify(links));
        this.onLinkClick.next(route);
    }

    getLinks(): Link[] {
        let data = localStorage.getItem('quickLinks') || '[]';
        let links: QuickLink[] = JSON.parse(data).slice(0, 4);
        return links.map(x => PREFIX_MAP[x.prefix]);
    }

    createLink(route: string): QuickLink | undefined {
        let prefix = ROUTE_MAP[route]
        if (!prefix) {
            return;
        }
        return {prefix: prefix, visits: 1, lastVisited: new Date()};
    }
}

export interface QuickLink {
    prefix: string;
    visits: number;
    lastVisited: Date;
}
